<script src="https://code.iconify.design/1/1.0.7/iconify.min.js"></script>
 <div id="card-footer" class="row rounded">
      <div class="col-xs-4 col-sm-4 col-md-4">
            <h1 style="margin-bottom: 5%; color: #E0FFFF;  font-family: 'Syne Mono', monospace; font-size: 30px;"><b>GIOVANNI SULLI – TRAINER</b> </h1>
            <ul>
                <li style="margin-bottom: 5%"><b>Personal Trainer Fitness & Bodybuilding </b></li>
                <li style="margin-bottom: 5%"><b>Educatore in Nutrizione Funzionale </b> </li>
                <li style="margin-bottom: 5%"><b>Specialista in Esercizio correttivo</b> </li>
                <li style="margin-bottom: 5%"><b>Specialista nell’applicazione di Taping Elastico</b> </li>
                <li style="margin-bottom: 5%"><b>Massaggiatore Sportivo</b> </li>
            </ul>
      </div>
      <div class="col-xs-3 col-sm-3 col-md-3"></div>
     <div class="col-xs-4 col-sm-4 col-md-4">
          <div class="row">
              <div class="col-6"><h1 style="color: #E0FFFF;  font-family: 'Syne Mono', monospace; font-size: 30px;"><b>CONTATTI</b></h1></div>
              <div class="col-2">
                  <a href="https://api.whatsapp.com/send?phone=393405919012">
                      <img  src="/assets/whatsapp.svg" alt="Logo" style="width: 50%;">
                  </a>
              </div>
              <div class="col-2">
                  <a href="https://www.facebook.com/giovanni.sulli">
                      <img  src="/assets/facebook.png" alt="Logo" style="width: 50%;">
                  </a>
              </div>
              <div class="col-2">
                  <a href="https://www.instagram.com/gio.sulli_personal.trainer/">
                      <img src="/assets/instagram.svg" alt="Logo" style="width: 50%;">
                  </a>
              </div>
          </div>
         <p><span class="material-icons">attach_email</span><b> EMAIL: giosulli.pt@gmail.com</b></p>
        <p><span class="material-icons">phone_iphone</span><b>TELEFONO: 3405919012</b></p>
         <p style="color: #E0FFFF"><b>Partita IVA: 12648860018</b></p>
        <p><span class="material-icons">house</span><B>MI TROVI:</B></p>
        <p style="color: #E0FFFF"><b>FitActive, via Giordano Bruno 206, Torino</b></p>
        <p style="color: #E0FFFF"><b>AirSport, via Torino 11 – Caselle Torinese </b></p>


     </div>
 </div>
